import { render, staticRenderFns } from "./Quiver.vue?vue&type=template&id=568febd9"
import script from "./Quiver.vue?vue&type=script&lang=js"
export * from "./Quiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports